import React from 'react';
export function AnnouncementBar() {
  return <div className="w-full text-white text-center py-2 px-4 text-sm font-medium" style={{
    background: '#000000'
  }} data-id="element-36">
      🚗 Get 20% Off All New Tires This Month!{' '}
      <span className="mx-2 opacity-60" data-id="element-37">|</span>
      24/7 Emergency Roadside Assistance: Call{' '}
      <a href="tel:3012549338" className="underline underline-offset-2 font-semibold transition-colors hover:text-yellow-100" data-id="element-38">
        (301) 254-9338
      </a>
    </div>;
}